import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Root from "./pages/Root";
import initStore from "./state/store";
import registerServiceWorker from "./util/registerServiceWorker";

const store = initStore({
  auth: {
    currentUser: null,
    loaded: false,
  },
});

ReactDOM.render(<Root store={store} />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js